export default {"src":"/_next/static/media/modern-bath.c8e3a90e.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};